export default __webpack_public_path__ + "static/media/neon-logo-hoz-wht-rgb.6d5be07f.svg";